import { combineReducers } from 'redux'

import { Company }                                  from '../../api'
import { api }                                      from '../../client'
import { convertCreateCompany, convertEditCompany } from '../../components/forms/schemas'
import { bind }                                     from '../../utils'
import createAction                                 from '../redux-utils/create-action'
import { Reducer }                                  from '../types'
import { createRequest }                            from './communication.duck'
import { ApplicationState }                         from './index'

const NAMESPACE = 'companies'

export const COMPANIES_EDITED = `[${NAMESPACE}] EDITED`
export const COMPANIES_DELETED = `[${NAMESPACE}] DELETED`
export const COMPANIES_CREATED = `[${NAMESPACE}] CREATED`
export const COMPANIES_GET_SUCCESS = `[${NAMESPACE}] GET_SUCCESS`

interface ByIdState {
  [ id: number ]: Company
}

const byId: Reducer<ByIdState> = (state = {}, action) => {
  const { type, payload } = action

  switch (type) {
    case COMPANIES_CREATED:
    case COMPANIES_EDITED: {
      const { id, ...rest } = payload

      return {
        ...state,
        [ id ]: { id, ...rest },
      }
    }

    case COMPANIES_DELETED: {
      const { id } = payload

      return {
        ...state,
        [ id ]: undefined,
      }
    }

    case COMPANIES_GET_SUCCESS:
      const { results } = payload

      const resultsById = (results as Company [])
        .reduce(
          (reduction, company) =>
            ({
              ...reduction, [ company.id ]: {
                ...company,
                contacts: (company as any).contacts ? (company as any).contacts : []
              },
            }),
          {},
        )

      return {
        ...state,
        ...resultsById,
      }

    default:
      return state
  }
}

type IdsState = number []
const ids: Reducer<IdsState> = (state = [], action) => {
  const { type, payload } = action

  switch (type) {
    case COMPANIES_CREATED: {
      const { id } = payload
      return [ ...state, id ]
    }

    case COMPANIES_DELETED: {
      const { id } = payload
      return state
        .filter(item => item !== id)
    }

    case COMPANIES_GET_SUCCESS: {
      const ids = (payload.results as Company [])
        .map(({ id }) => id)

      /*
       * TODO: extract into util (array-unique) you're using this in two places
       * */
      const unique = new Set([ ...state, ...ids ])
      return Array.from(unique)
    }

    default:
      return state
  }
}

export interface CompaniesState {
  byId: ByIdState
  ids: IdsState
}

export default combineReducers({
  ids,
  byId,
})

const bindApi = bind(api)

const handleCompanyGet = response =>
  createAction(COMPANIES_GET_SUCCESS, response)

const handleCompanyEdited = (response, id, body) =>
  createAction(
    COMPANIES_EDITED,
    {
      id,
      ...body,
    },
    {
      toast: {
        message: 'companyUpdated',
      },
    }
  )

const handleCompanyCreated = response =>
  createAction(
    COMPANIES_CREATED,
    response,
    {
      toast: {
        message: 'companyCreated',
      },
    },
  )

/*

 GET

 */
export const companiesGetRequest = createRequest({
  request:        bindApi(api.getCompanies),
  namespace:      NAMESPACE,
  successHandler: handleCompanyGet,
})

/* EDIT */
export const editCompanyRequest = createRequest({
  request:        convertEditCompany(bindApi(api.updateCompany)),
  namespace:      'company-edit',
  successHandler: handleCompanyEdited,
})

/* CREATE */
export const createCompanyRequest = createRequest({
  request:        convertCreateCompany(bindApi(api.createCompany)),
  namespace:      'company-create',
  successHandler: handleCompanyCreated,
})

/* SELECTORS */
export const selectCompanies = ({ companies: { ids, byId } }: ApplicationState) =>
  ids.map(id => byId[ id ])



// WEBPACK FOOTER //
// ./src/redux/ducks/companies.duck.ts